(() => {
  const revealElements = () => {
    const elements = Array.from(document.querySelectorAll('.reveal-on-scroll:not(.is-visible)'));
    if (!elements.length) return;

    const viewportBottom = (window.innerHeight || document.documentElement.clientHeight) * 0.95;
    const aboveFold = [];
    const belowFold = [];

    elements.forEach((element) => {
      const top = element.getBoundingClientRect().top;
      if (top < viewportBottom) aboveFold.push(element);
      else belowFold.push(element);
    });

    // Sudah di viewport: tampil langsung (cegah blink putih), tanpa nunggu observer
    aboveFold.forEach((element) => {
      element.style.transition = 'none';
      element.classList.add('is-visible');
      window.requestAnimationFrame(() => {
        element.style.transition = '';
      });
    });

    if (!belowFold.length) return;

    if (!('IntersectionObserver' in window)) {
      belowFold.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    belowFold.forEach((element) => observer.observe(element));
  };

  const initProductSwatches = () => {
    document.querySelectorAll('[data-product-swatch]').forEach((swatch) => {
      if (swatch.dataset.swatchBound === 'true') return;
      swatch.dataset.swatchBound = 'true';

      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const card = swatch.closest('.product-card');
        if (!card) return;

        const imageUrl = swatch.getAttribute('data-image-url');
        const imageSrcset = swatch.getAttribute('data-image-srcset');
        const variantId = swatch.getAttribute('data-variant-id');
        const primaryImage = card.querySelector('.product-card__image--primary');
        const wishlistBtn = card.querySelector(
          '.smartwishlist[data-sculpt-source="card"], .smartwishlist.product-card__wishlist, .product-card__wishlist'
        );

        if (primaryImage && imageUrl) {
          primaryImage.src = imageUrl;
          if (imageSrcset) {
            primaryImage.srcset = imageSrcset;
          } else {
            primaryImage.removeAttribute('srcset');
          }
          card.classList.add('is-swatch-locked');
        }

        if (wishlistBtn && variantId) {
          wishlistBtn.setAttribute('data-variant', variantId);
          if (window.jQuery) {
            window.jQuery(wishlistBtn).data('variant', variantId);
          }
          wishlistBtn.querySelectorAll('[data-variant]').forEach((el) => {
            el.setAttribute('data-variant', variantId);
            if (window.jQuery) window.jQuery(el).data('variant', variantId);
          });
        }

        const swatches = card.querySelectorAll('[data-product-swatch]');
        swatches.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('is-selected');
        swatch.setAttribute('aria-pressed', 'true');
      });
    });
  };

  const SPLIDE_ARROW =
    '<svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6.15 3.13c.2-.19.51-.18.7.02l3.74 4c.18.19.18.49 0 .68l-3.75 3.99c-.19.2-.51.21-.71.02 -.21-.19-.22-.51-.03-.71l3.42-3.66 -3.43-3.66c-.19-.21-.18-.52.02-.71Z"></path></svg>';

  const updateSplideArrows = (scope = document) => {
    scope.querySelectorAll('.splide__arrow--prev, .splide__arrow--next').forEach((button) => {
      button.innerHTML = SPLIDE_ARROW;
    });
  };

  const decorateSplide = (splide, scope) => {
    const root = scope || splide.root;
    const apply = () => {
      updateSplideArrows(root);
      window.requestAnimationFrame(() => updateSplideArrows(root));
    };

    splide.on('mounted', apply);
    splide.on('updated', apply);
    splide.on('resize', apply);
    splide.on('refresh', apply);
  };

  let splideArrowResizeTimer;
  window.addEventListener('resize', () => {
    window.clearTimeout(splideArrowResizeTimer);
    splideArrowResizeTimer = window.setTimeout(() => updateSplideArrows(), 120);
  });

  window.updateSplideArrows = updateSplideArrows;
  window.decorateSplide = decorateSplide;

  document.addEventListener('DOMContentLoaded', () => {
    revealElements();
    initProductSwatches();
    updateSplideArrows();
  });
  document.addEventListener('shopify:section:load', (event) => {
    revealElements();
    initProductSwatches();
    updateSplideArrows(event.target);
  });
})();
